import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e1aece3")

_pushScopeId("data-v-3e1aece3")
const _hoisted_1 = {
  class: "main",
  "data-test": "koiListItem"
}
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "koi" }
const _hoisted_4 = { class: "details" }
const _hoisted_5 = { class: "koi__size" }
const _hoisted_6 = { class: "koi__price" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "pi pi-angle-right" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ['tag', _ctx.statusStyle]
    }, _toDisplayString(_ctx.koi.id), 3),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("img", {
          src: _ctx.getThumbnailUrl(_ctx.koi.videoUrl),
          alt: "Imagem",
          class: "koi__image"
        }, null, 8, ["src"]),
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.koi.size), 1),
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.formatCurrency(_ctx.koi.price)), 1)
        ])
      ]),
      _hoisted_7
    ])
  ]))
})